import Autorenew from "@material-ui/icons/Autorenew";
import CloudUpload from "@material-ui/icons/CloudUpload";
import FindInPage from "@material-ui/icons/FindInPage";
import Print from "@material-ui/icons/Print";
import SaveIcon from "@material-ui/icons/Save";
import SkipNext from "@material-ui/icons/SkipNext";
import SkipPrevious from "@material-ui/icons/SkipPrevious";
import React, { useEffect, useState } from "react";

import { Button, TextField, Typography } from "@mui/material";
import { headerBarStyle } from "../../../styles";
import convertNumberToWords from "../../../utils/Level/utils";

function VoucherBar(props) {
  console.log(props);
  const [indexEdit, setIndexEdit] = useState(props.editIndex);
  const classes = headerBarStyle();

  const handleSave = () => {
    console.log(props);
  };

  useEffect(() => {
    setIndexEdit(props.editIndex);
  }, [props.editIndex]);

  return (
    <div
      className={classes.root}
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        // backgroundColor: indexEdit ? '#379683' : '#8EE4AF',
      }}
    >
      {indexEdit ? (
        <Button
          variant="contained"
          style={{
            backgroundColor: "red",
            color: "white",
          }}
          onClick={props.deleteCallback}
        >
          Delete
        </Button>
      ) : (
        <Button variant="contained" onClick={props.handleSingleVoucher}>
          single Entry Voucher
        </Button>
      )}
      {indexEdit ? (
        <Button
          disabled={props.disableSave}
          style={{
            backgroundColor: "#379683",
            color: "white",
          }}
          variant="contained"
          className={classes.button}
          startIcon={<CloudUpload />}
          onClick={props.saveCallback}
        >
          Update
        </Button>
      ) : (
        <Button
          disabled={props.disableSave}
          style={{
            backgroundColor: "#379683",
            color: "white",
          }}
          variant="contained"
          className={classes.button}
          startIcon={<SaveIcon />}
          onClick={props.saveCallback}
        >
          Save
        </Button>
      )}
      <Button
        disabled={props.disableCancel}
        variant="contained"
        style={{
          backgroundColor: "#379683",
          color: "white",
        }}
        className={classes.button}
        startIcon={<Autorenew />}
        onClick={props.cancelCallback}
      >
        Cancel
      </Button>
      {indexEdit ? (
        <>
          <Button
            disabled={props.disablePrint}
            variant="contained"
            style={{
              backgroundColor: "#379683",
              color: "white",
            }}
            className={classes.button}
            startIcon={<Print />}
            onClick={props.printCallback}
          >
            Print
          </Button>
          <Button
            disabled={props.disablePrint}
            variant="contained"
            style={{
              backgroundColor: "blue",
              color: "white",
              marginLeft: 5,
              marginRight: 5,
            }}
            onClick={props.changeMode}
          >
            New Voucher
          </Button>
        </>
      ) : (
        <Button
          disabled={props.disableDelete}
          variant="contained"
          style={{
            backgroundColor: "#379683",
            color: "white",
          }}
          className={classes.button}
          startIcon={<FindInPage />}
          onClick={props.findCallback}
        >
          Find
        </Button>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          padding: 5,
        }}
      >
        {/* <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "censtrter",
            justifyContent: "flex-start",
            marginBottom: "2%",
          }}
        >
          <Button
            disabled={props.disablePrint}
            variant="contained"
            className={classes.button}
            startIcon={<Print />}
            style={{
              backgroundColor: "#379683",
              color: "white",
            }}
            onClick={props.printCallback}
            style={{
              marginRight: "2%",
              backgroundColor: "#379683",
              color: "white",
            }}
          >
            Lock
          </Button>
          <Button
            disabled={props.disablePrint}
            variant="contained"
            style={{
              backgroundColor: "#379683",
              color: "white",
            }}
            className={classes.button}
            startIcon={<Print />}
            onClick={props.printCallback}
          >
            Unlock
          </Button>
        </div> */}
        {indexEdit ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              disabled={props.disablePrint}
              variant="contained"
              style={{
                backgroundColor: "#379683",
                color: "white",
              }}
              className={classes.button}
              startIcon={<SkipPrevious />}
              onClick={props.handlePre}
            >
              {"Pre"}
            </Button>
            <Button
              disabled={props.disableDelete}
              variant="contained"
              style={{
                backgroundColor: "red",
                color: "white",
              }}
              className={classes.button}
              startIcon={<FindInPage />}
              onClick={props.findCallback}
            >
              Find
            </Button>
            <Button
              disabled={props.disablePrint}
              variant="contained"
              style={{
                backgroundColor: "#379683",
                color: "white",
              }}
              className={classes.button}
              startIcon={<SkipNext />}
              onClick={props.handleNext}
            >
              {"Next"}
            </Button>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          padding: 5,
          flex: 1,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <TextField
            id="outlined-disabled"
            label="Debit Total"
            variant="standard"
            style={{ backgroundColor: "#EDF5E1" }}
            value={props.debitTotal}
            InputProps={{
              readOnly: true,
            }}
          />
          <TextField
            id="outlined-disabled"
            label="Credit Total"
            variant="standard"
            value={props.creditTotal}
            style={{ backgroundColor: "#EDF5E1" }}
            InputProps={{
              readOnly: true,
            }}
          />
          <TextField
            id="outlined-disabled"
            label="Difference"
            variant="standard"
            value={props.difference}
            style={{ backgroundColor: "#EDF5E1" }}
            InputProps={{
              readOnly: true,
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            width: "100%",
            marginTop: "2%",
            backgroundColor: "#EDF5E1",
          }}
        >
          <Typography
            variant="subtitle2"
            component="subtitle2"
            gutterBottom
            style={{ marginRight: "5%" }}
          >
            Amount in Words:
          </Typography>
          <Typography variant="subtitle2" component="subtitle2" gutterBottom>
            {props.difference == 0
              ? convertNumberToWords(props.creditTotal)
              : ""}
          </Typography>
        </div>
      </div>
    </div>
  );
}

export default VoucherBar;
